const PROD_ENV_NAME = 'prod';

/**
 * Third-party tracking and support widgets (GTM, Pylon) are only loaded in
 * production, so local, dev, demo and pre-prod builds do not pollute
 * production analytics or open real support conversations.
 */
export const isProdEnvironment = (): boolean =>
  import.meta.env.VITE_ENV_NAME === PROD_ENV_NAME;
